import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { StorageService } from 'app/core/auth/storage.service';

@Component({
    selector: 'vg-select-outlet',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './select-outlet.component.html',
})
export class VgSelectOutletComponent implements OnInit {
    outlets: any[] = [];

    constructor(
        private router: Router,
        private storage: StorageService
    ) {}

    ngOnInit(): void {
        this.outlets = this.storage.getOutlets();

        if (this.outlets.length === 0) {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
            return;
        }

        const selectedOutlet = this.storage.getOutlet();
        if (selectedOutlet) {
            this.router.navigate(['/dashboard'], { replaceUrl: true });
        }
    }

    selectOutlet(outlet: any): void {
        this.storage.setOutlet(outlet);
        this.router.navigate(['/dashboard'], { replaceUrl: true });
    }
}
